import {handleActions} from 'redux-actions';
import {Client} from '@stomp/stompjs';
import {
  key,
  wsConnect,
  wsDisconnect,
  wsReconnect,
  wsSubscribe,
  wsUnsubscribe,
  wsListen,
  wsUnlisten,
  wsUnlistenAll
} from './actions';

import {wsError, wsSetSubscription, wsSuccess} from 'App/util/redux/socket/actions';
import {DEV_MODE} from 'App/util/common/helper';

export const selectors = {
  status: state => state[key].status,
  client: state => state[key].client,
  listener: state => state[key].listener,
  storage: state => state[key].storage,
  connectionEstablished: state => state[key].connectionEstablished,
  subscription: state => state[key].subscription,
};

const initialState = {
  status: 'stopped',
  connectionEstablished: Date.now(),
  connected: false,
  listener: [],
  client: null,
  subscription: null
};

// helper function
const addToListener = (key, subject, callback, listener) => {
  let newListener = listener;

  newListener[key] = listener[key] || [];
  newListener[key][subject] = listener[key][subject] || [];
  newListener[key][subject] = callback;

  return newListener;
};

const removeFromListener = (key, subject, listener) => {
  let newListener = listener;

  delete newListener[key][subject];
  if (Object.values(newListener[key]) == 0) {
    delete newListener[key];
  }

  return newListener;
};

export default handleActions({
  [wsConnect]: (state, action) => ({
    ...state,
    client: new Client(),
    connected: false,
    status: 'connecting',
    connectionEstablished: Date.now()
  }),
  [wsDisconnect]: (state, action) => ({
    ...state,
    connected: false,
    status: 'disconnect'
  }),
  [wsReconnect]: (state, action) => ({
    ...state,
    status: 'reconnect',
    connected: false,
    connectionEstablished: Date.now()
  }),
  [wsSuccess]: (state, action) => ({
    ...state,
    connected: true,
    status: 'ws connection established'
  }),
  [wsError]: (state, action) => ({
    ...state,
    status: 'ws error'
  }),
  [wsListen]: (state, action) => ({
    ...state,
    // add new listener
    listener: addToListener(
      action.payload.key,
      action.payload.subject,
      action.payload.callback,
      state.listener
    ),
    status: 'listen ' + action.payload.key
  }),
  [wsUnlisten]: (state, action) => ({
    ...state,
    listener: removeFromListener(
      action.payload.key,
      action.payload.subject,
      state.listener
    ),
    status: 'wsUnlisten ' + action.payload.key + ' | ' + action.payload.subject
  }),
  [wsSubscribe]: (state, action) => ({
    ...state,
    status: 'subscribe '
  }),
  [wsUnsubscribe]: (state, action) => ({
    ...state,
    status: 'unsubscribe '
  }),
  [wsUnlistenAll]: (state, action) => ({
    ...state,
    listener: initialState.listener,
    status: 'wsUnlisten all'
  }),
  [wsSetSubscription]: (state, action) => ({
    ...state,
    subscription: action.payload.value,
    status: 'set subscription'
  })
}, initialState);



// WEBPACK FOOTER //
// ./src/util/redux/socket/reducer.js